export default {
  data () {
    return {
      formRules: {
        squadName: [{ required: true, message: '请输入球队名称', trigger: 'blur' }],
        // description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
        squadSex: [{ required: true, message: '请选择当前球队类型', trigger: 'change' }],
        squadLevel: [{ required: true, message: '请选择当前球队级别', trigger: 'change' }],
        squadRanking: [{ required: true, message: '请选择获取名次', trigger: 'change' }]
      }
    }
  }
}
